import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import MuiReactSelect from 'src/components/common/MuiReactSelect';
import { useMassActionState } from 'src/components/massAction/MassActionStateContext';
import massActionUtils from 'src/components/massAction/state/utils';

const diffusionTypes = ['legal', 'advertising', 'news'];

const DiffusionTypeButton = ({ actionType }) => {
  const { t } = useTranslation();
  const [{ selectedDiffusionType }, setMassActionState] = useMassActionState();
  const stopSmsText = useSelector(state => state.app.config.stopSmsText);

  return (
    <MuiReactSelect
      error={!selectedDiffusionType}
      onChange={value => {
        setMassActionState(prevState => ({
          ...prevState,
          selectedDiffusionType: value,
          contentValidity: massActionUtils.getContentValidity({
            actionType,
            object: prevState.objectEditor && prevState.objectEditor.getData(),
            content: prevState.editor.getData(),
            min: value === 'advertising' ? stopSmsText.length : 0,
          }),
        }));
      }}
      isMulti={false}
      value={(selectedDiffusionType && [selectedDiffusionType]) || []}
      options={diffusionTypes.map(dt => ({
        label: t(`smartmessaging.diffusionType.${dt}`),
        value: dt,
      }))}
    />
  );
};

DiffusionTypeButton.propTypes = {
  actionType: PropTypes.number,
};

DiffusionTypeButton.defaultProps = {
  actionType: null,
};

export default DiffusionTypeButton;
